import React from 'react'

const HomeTasComp = () => {
  return (
    <section id="c-sectionTas" className="c-sectionWrapper">
		<div className="container">
			<div className="c-sectionHeader">
				<h5 className="c-heading46Bold">Transparency &nbsp;|&nbsp;  Accuracy &nbsp;|&nbsp; Scalability</h5>
				<div className="row justify-content-lg-center">
					<div className="col-lg-8 col-md-12">
						{/* <!-- <p className="c-para20Light"> Is all that ensure </p> --> */}
					</div>
				</div>
			</div>				
		</div>
		
		<div className="container-fluid">
			<div className="row">
				<div className="container">
					<ul className="nav nav-tabs" id="c-tasTab" role="tablist">
						<li className="nav-item" role="presentation">
							<a className="nav-link active" 
								id="tas-api-lending-tab" 						
								href="#tas-api-lending" data-toggle="tab"  role="tab" aria-controls="tas-api-lending" aria-selected="true">API Lending</a>
						</li>
						<li className="nav-item" role="presentation">
							<a className="nav-link" 
								id="tas-banking-apis-tab" 
								href="#tas-banking-apis" data-toggle="tab" role="tab" aria-controls="tas-banking-apis" aria-selected="false">Banking APIs</a>
						</li>
						<li className="nav-item" role="presentation">
							<a className="nav-link" 
								id="tas-digital-services-tab" 
								href="#tas-digital-services" data-toggle="tab" role="tab" aria-controls="tas-digital-services" aria-selected="false">Digital Services</a>
						</li>
						<li className="nav-item" role="presentation">
							<a className="nav-link" 
								id="tas-loan-platform-tab" 
								href="#tas-loan-platform" data-toggle="tab" role="tab" aria-controls="tas-loan-platform" aria-selected="false">Loan Platform</a>
						</li>
						<li className="nav-item" role="presentation">
							<a className="nav-link" 
								id="tas-data-analytics-tab" 
								href="#tas-data-analytics" data-toggle="tab" role="tab" aria-controls="tas-data-analytics" aria-selected="false">Data Analytics</a>
						</li>

						<li className="nav-item dropdown">
							<a className="nav-link dropdown-toggle active" data-toggle="dropdown" href="#" role="button" aria-expanded="false">API Lending</a>
							<div className="dropdown-menu">
							<a className="dropdown-item active" href="#tas-api-lending" data-toggle="tab"  role="tab" aria-controls="tas-api-lending">API Lending</a>
							<a className="dropdown-item" href="#tas-banking-apis" data-toggle="tab" role="tab" aria-controls="tas-banking-apis">Banking APIs</a>
							<a className="dropdown-item" href="#tas-digital-services" data-toggle="tab" role="tab" aria-controls="tas-digital-services">Digital Services</a>
							<a className="dropdown-item" href="#tas-loan-platform" data-toggle="tab" role="tab" aria-controls="tas-loan-platform">Loan Platform</a>
							<a className="dropdown-item" href="#tas-data-analytics" data-toggle="tab" role="tab" aria-controls="tas-data-analytics">Data Analytics</a>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div className="container">
			<div className="tab-content" id="c-tasTabContent">
			  <div className="tab-pane fade show active" id="tas-api-lending" role="tabpanel" aria-labelledby="tas-api-lending-tab">
				<div className="row">
					<div className="col-lg-6 col-md-12">
						<h5 className="c-tasTabMainTitle">API Based Lending</h5>
						<p>
							We're paperless, which means we're fast as we offer an end-to-end digital journey.
						</p>
						<ul>
							<li>Real-time Transactions Access</li>
							<li>Convenience in Financial Management</li>
							<li>Adequately User Experience</li>
							<li>High-Level Data Security </li>
							<li>Cost-Effective & Efficient </li>
							<li>Unlock New Prospects </li>
						</ul>
					</div>
					<div className="col-md-6 col-sm-12">
						<img src="./images/home/transparency/tas_apis_lending.png" className="img-fluid c-tasTabContentImg" alt="" title="" />
					</div>
				</div>
			  </div>
			  <div className="tab-pane fade" id="tas-banking-apis" role="tabpanel" aria-labelledby="tas-banking-apis-tab">
				<div className="row">
					<div className="col-lg-6 col-md-12">
						<h5 className="c-tasTabMainTitle">Banking APIs</h5>
						<p>
							Uncomplicated plug-and-play APIs permit you to efficiently plug into an earnings ecosystem and create your lending journey at the most earlier.
						</p>
						<ul>
							<li>FI-MEN - Custom-built in-house lending platform for digital lending</li>
							<li>Payment gateway and digital payments strategic partnership with payment providers. ENACH & UPI. The conventional understanding of the NBFC sector's advantage of visibility and accessibility for repayments from its customers</li>
							<li>API driven Tech</li>
							<li>Cloud-based infra</li>
							<li>Payment gateway</li>
						</ul>
					</div>
					<div className="col-md-6 col-sm-12">
						<img src="./images/home/transparency/banking-api.png" className="img-fluid c-tasTabContentImg" alt="" title="" />
					</div>
				</div>
			  </div>
			  <div className="tab-pane fade" id="tas-digital-services" role="tabpanel" aria-labelledby="tas-digital-services-tab">
				<div className="row">
					<div className="col-lg-6 col-md-12">
						<h5 className="c-tasTabMainTitle">Digital Services</h5>
						<p>
							Our strong credit examination procedure associated with access to unit data and third-party transaction data allows us to virtually evaluate your borrowers, thereby assisting you to overlook the lending risk.
						</p>
						<ul>
							<li>Borrower evaluation</li>
							<li>Credit Decisioning </li>
							<li>Loan Origination Management</li>
							<li>Reconciliation and risk control</li>
							<li>Recommend Borrower as per Lending Policy</li>
						</ul>
					</div>
					<div className="col-md-6 col-sm-12">
						<img src="images/home/transparency/digital-service.png" className="img-fluid c-tasTabContentImg" alt="" title="" />
					</div>
				</div>
			  </div>
			  <div className="tab-pane fade" id="tas-loan-platform" role="tabpanel" aria-labelledby="tas-loan-platform-tab">
				<div className="row">
					<div className="col-lg-6 col-md-12">
						<h5 className="c-tasTabMainTitle">Loan Platform</h5>
						<p>
							Our in-depth tech-driven products help in the end-to-end control of a loan, starting with credit risk inspection and buyer onboarding to clusters and repayments 
						</p>
						<ul>
							<li>Complete customer onboarding to disbursals platforms</li>
							<li>Business rule engines and digital underwriting platform</li>
							<li>Loan Origination Management </li>
							<li>blended collection and repayment API's</li>
							<li>Recommendation Engine</li>
						</ul>
					</div>
					<div className="col-md-6 col-sm-12">
						<img src="./images/home/transparency/loan-platform.png" className="img-fluid c-tasTabContentImg" alt="" title="" />
					</div>
				</div>
			  </div>
			  <div className="tab-pane fade" id="tas-data-analytics" role="tabpanel" aria-labelledby="tas-data-analytics-tab">
				<div className="row">
					<div className="col-lg-6 col-md-12">
						<h5 className="c-tasTabMainTitle">Data Analytics</h5>
						<p>
							Power data to drive strategic insights that can help you build a robust business model, at scale.
						</p>
						<ul>
							<li>Captured an extensive customer base with 3 dimensional (demographic, geographic, transactional) and behavioural data points </li>
							<li>dedupe with existing base</li>
							<li>leverage customers rating</li>
							<li>default scoring model for risk assessment</li>
							<li>tendency to borrow scorecard </li>
							<li>information enrichment</li> 
							<li>occurrence based analytics spurs </li>
							
						</ul>
					</div>
					<div className="col-md-6 col-sm-12">
						<img src="./images/home/transparency/data-analytics.png" className="img-fluid c-tasTabContentImg" alt="" title="" />
					</div>
				</div>
			  </div>
			</div>
		</div>
	</section>
  )
}

export default HomeTasComp